
<div class="datepicker-only-month-select">
    <ngb-datepicker 
        class="form-control p-0" 
        [minDate]="minDate"
        (navigate)="onDateNavigate($event)">
    </ngb-datepicker>
</div>

